import React, { Component } from 'react';
import { connect } from 'react-redux';
import './filter.scss';
import { Checkbox, Form } from 'element-react';
import { actionCreators } from '../../store';
import { Link } from 'react-router-dom';

class Filter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: {
        domain: '',    // 科技/成果领域
        maturity: '',  // 成熟度
        operation: '', // 合作需求
      }
    }
  }

  handleChange(key, value) {

    const { filterData } = this.props;

    this.setState({
      form: Object.assign({}, this.state.form, { [key]: value })
    }, () => {
      const parmas = {
        operation: this.state.form.operation.toString(),
        domain: this.state.form.domain.toString(),
        maturity: this.state.form.maturity.toString()
      }
      filterData(parmas);
    });
  }

  render() {

    const { domain, maturity, operation } = this.props;

    return (
      <div className="filter" id="anchorTop">
        <div className="common-content-width">
          <div className="filter__send-box">
            <Link to="/publish" className="filter__send--result" >发布成果</Link>
            <Link to="/demand" className="filter__send--request">发布需求</Link>
          </div>

          <div className="filter__bar">

            <Form ref="form" labelPosition="left" model={this.state.form}>

              <Form.Item className="filter__bar--item" label="科技/成果领域:" >
                <Checkbox.Group value={this.state.form.domain} onChange={this.handleChange.bind(this, 'domain')}>
                  {
                    domain.map((item) => {
                      return (
                        <Checkbox label={item.get('val')} key={item.get('val')} name="domain">{item.get('name')}</Checkbox>
                      )
                    })
                  }
                </Checkbox.Group>
              </Form.Item>

              <Form.Item className='filter__bar--item' label="科技/成果成熟度:" >
                <Checkbox.Group value={this.state.form.maturity} onChange={this.handleChange.bind(this, 'maturity')}>
                  {
                    maturity.map((item) => {
                      return (
                        <Checkbox label={item.get('val')} key={item.get('val')} name="maturity">{item.get('name')}</Checkbox>
                      )
                    })
                  }
                </Checkbox.Group>
              </Form.Item>

              <Form.Item className="filter__bar--item" label="合作需求:" >
                <Checkbox.Group value={this.state.form.operation} onChange={this.handleChange.bind(this, 'operation')}>
                  {
                    operation.map((item) => {
                      return (
                        <Checkbox label={item.get('val')} key={item.get('val')} name="operation">{item.get('name')}</Checkbox>
                      )
                    })
                  }
                </Checkbox.Group>
              </Form.Item>

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

const mspState = (state) => ({
  domain: state.getIn(['ach', 'domain']),
  maturity: state.getIn(['ach', 'maturity']),
  operation: state.getIn(['ach', 'operation'])
});

const mapDispatch = (dispatch) => ({
  filterData(obj) {
    dispatch(actionCreators.fetchAchData(obj));
  }
});

export default connect(mspState, mapDispatch)(Filter);
